import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { ApiRoutes } from "./Routes";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import formValidation from "../common/utils/formValidation";
import { renderOptions } from "../common/Options";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { connectionString } = formData;
  const subscriptions = [
    { label: "Global Service", value: "GLOBAL" },
    { label: "US Government", value: "US_GOV" },
    { label: "US DOD", value: "US_DOD" }
  ];
  const handleSubmit = () => {
    var _a, _b, _c, _d;
    const fetcher = fetch("POST", qualifyUrl(ApiRoutes.INTEGRATIONS.Graph.CHECK_CREDENTIALS), {
      tenant_id: ((_a = formData == null ? void 0 : formData.tenantId) == null ? void 0 : _a.value) || "",
      client_id: ((_b = formData == null ? void 0 : formData.clientId) == null ? void 0 : _b.value) || "",
      client_secret: ((_c = formData == null ? void 0 : formData.clientSecret) == null ? void 0 : _c.value) || "",
      subscription_type: ((_d = formData == null ? void 0 : formData.subscriptionType) == null ? void 0 : _d.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to Microsoft Graph API using provided configuration."
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to Microsoft Graph API using provided configuration."
      });
    });
  };
  const isFormValid = formValidation.isFormValid(
    ["graphName", "tenantId", "clientId", "clientSecret", "subscriptionType"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      className: "col-md-7",
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "graphName",
        type: "text",
        fieldData: formData.graphName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "tenantId",
        type: "text",
        fieldData: formData.tenantId,
        onChange,
        label: "Tenant ID",
        help: "The Tenant ID for the registered app.",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        label: "Client ID",
        help: "The Client ID for the registered app.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientSecret",
        type: "password",
        onChange,
        fieldData: formData.clientSecret,
        label: "Client Secret",
        help: "The Client Secret for the registered app.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        name: "subscriptionType",
        id: "subscriptionType",
        onChange,
        fieldData: formData.subscriptionType,
        help: "Azure subscription type for your organization.",
        required: true,
        label: "Subscription Type"
      },
      renderOptions(subscriptions, "Choose a Subscription")
    )
  );
};
export default StepAuthorize;
